import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import MaterialGroupSelect from "../MaterialGroupSelect";
import MaterialLocationSelect from "../MaterialLocationSelect";
import { toast } from "react-toastify";
import LoadingOverlay from "../LoadingOverlay";
import ConfirmDialog from "../ConfirmDialog";

function MaterialListModal({ dataSet, onClose, refreshData }) {
  const listUnit = ["ROLL", "SHEET", "PLY", "KG", "PCS", "RIM"];

  const [selectedMatGroup, setSelectedMatGroup] = useState(null);
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [productUnit, setProductUnit] = useState(listUnit[0]);
  const [productLocation, setProductLocation] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    if (dataSet) {
      setProductName(dataSet.product_name);
      setProductCode(dataSet.product_code);
      setProductUnit(dataSet.unit);
    }
  }, [dataSet]);

  const handleProductUnitChange = (e) => {
    setProductUnit(e.target.value);
  };
  const handleProductLocationChange = (locationId) => {
    setProductLocation(locationId);
  };

  const handleProductNameChange = (e) => {
    setProductName(e.target.value);
  };

  const handleProductCodeChange = (e) => {
    setProductCode(e.target.value);
  };

  const handleMatGroupChange = (GroupId) => {
    setSelectedMatGroup(GroupId);
  };

  const updateOrder = async (e) => {
    try {
      setIsLoading(true);
      const response = await axios.patch(
        `https://eps.elkomprintama.com/patch/api/store/store/mats`,
        {
          productCode: productCode.toUpperCase(),
          productName: productName.toUpperCase(),
          groupId: selectedMatGroup,
          unit: productUnit,
          productLocationId: productLocation,
          productId: dataSet.product_id,
        }
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
        setProductName("");
        setProductCode("");
        onClose();
        refreshData();
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!productName || !productCode || !selectedMatGroup) {
      toast.warning("Please fill in all required fields");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <div className="relative max-w-3xl w-full bg-gray-100 p-6 rounded-lg shadow-md">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <MaterialLocationSelect
          dataSet={dataSet}
          onChangeList={handleProductLocationChange}
        />

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="md:col-span-4">
            <label
              htmlFor="product_name"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Product Name
            </label>
            <input
              id="product_name"
              name="product_name"
              type="text"
              placeholder="Product Name"
              value={productName}
              onChange={handleProductNameChange}
              className="mt-1 block w-full uppercase border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>

          <div>
            <label
              htmlFor="product_code"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Product Code
            </label>
            <input
              id="product_code"
              name="product_code"
              type="text"
              placeholder="Code"
              value={productCode}
              onChange={handleProductCodeChange}
              className="mt-1 block w-full uppercase border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>
        </div>

        <MaterialGroupSelect
          dataSet={dataSet}
          onChangeList={handleMatGroupChange}
        />

        <div>
          <label
            htmlFor="product_unit"
            className="block text-sm font-medium text-gray-700 uppercase"
          >
            Unit
          </label>
          <select
            id="product_unit"
            name="product_unit"
            onChange={handleProductUnitChange}
            value={productUnit}
            className="mt-1 block w-full border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
          >
            {Array.isArray(listUnit) ? (
              listUnit.map((data, index) => (
                <option value={data} key={`listU-${index}`}>
                  {data}
                </option>
              ))
            ) : (
              <option value="">Loading...</option>
            )}
          </select>
        </div>

        <div className="w-full space-y-3">
          <Button fullSized type="submit" color="blue">
            Update
          </Button>
          <Button
            fullSized
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Close
          </Button>
        </div>
        {isLoading && <LoadingOverlay message="loading..." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to insert the data?"
            onConfirm={() => {
              setShowConfirm(false);
              updateOrder();
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
      </form>
    </div>
  );
}

export default MaterialListModal;
